import {Dispatch} from "redux";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {apiLink} from "@web2/ap-api-routes";
import {catch400} from "@web2/ap-request";
import {createRequestActionTypes} from "@web2/ap-request-state";

import {getAuthorizedRequest} from "../../app/utils/authorized_request";

const fetchAgentsListErrorText =
    "Wystąpił błąd związany z pobraniem listy agentów w Twojej agencji. Jeżeli będzie się powatarzał, skontaktuj się z administratorem aplikacji.";

const FETCH_AGENTS_LIST = "agents-list/FETCH";
export const fetchAgentsListActionTypes = createRequestActionTypes(FETCH_AGENTS_LIST);

export const fetchAgentsList = () => (dispatch: Dispatch) => {
    dispatch({type: fetchAgentsListActionTypes.start});

    const url = apiLink.contractors.agentList({});
    return getAuthorizedRequest(url(null))
        .then((response) => {
            dispatch({type: fetchAgentsListActionTypes.success, result: response});
        })
        .catch(
            catch400((err) => {
                dispatch({type: fetchAgentsListActionTypes.error, error: err});
                dispatch(addAlert({type: AlertType.ERROR, text: fetchAgentsListErrorText}, 5000));
            })
        );
};
